import { connectStorageEmulator, getStorage } from "firebase/storage";
import { _firebase } from "./firebase.auth";

const env = import.meta.env;
export const storage = getStorage(_firebase, env.REACT_APP_STORAGE_BUCKET);
if (env.REACT_APP_STORAGE_URL?.includes("localhost")) {
  const [host = "localhost", port = 9198] =
    env.REACT_APP_STORAGE_URL.split(":");
  connectStorageEmulator(storage, host, Number(port));
}
